import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { User } from "src/app/shared/models";
import { Discipline } from "src/app/shared/models/discipline";
import { UserDisciplineBusinessUnit } from "src/app/shared/models/user-trigger-business-unit";

@Injectable({
  providedIn: "root",
})
export class UserDisciplineBusinessUnitService {
  constructor(private http: HttpClient) {}

  apiRoot = `${environment.apiUrl}UserDisciplineBusinessUnit`;

  public getAllUsersByDiscId(discId: number): Observable<User[]> {
    return this.http.get<User[]>(
      `${this.apiRoot}/getAllUsersByDisciplineId/${discId}`
    );
  }

  public getAllUsersByBuId(buId: number): Observable<User[]> {
    return this.http.get<User[]>(
      `${this.apiRoot}/getAllUsersByBusinessUnitId/${buId}`
    );
  }

  public getAllUsersByBusinessUnit(businessUnit: string): Observable<User[]> {
    return this.http.get<User[]>(
      `${this.apiRoot}/getAllUsersByBusinessUnit/${businessUnit}`
    );
  }

  public getAllDiscApprovers(userId: number): Observable<Discipline[]> {
    return this.http.get<Discipline[]>(
      `${this.apiRoot}/getAllDiscApprovers/${userId}`
    );
  }

  public getAllDiscApproversByUserIdAndBusinessUnitId(
    userId: number,
    businessUnitId: number
  ): Observable<Discipline[]> {
    return this.http.get<Discipline[]>(
      `${this.apiRoot}/getAllDiscApproversByUserIdAndBusinessUnitId/${userId}/${businessUnitId}`
    );
  }

  public getAllDiscApproversByUniqueKey(
    uniqueKey: string
  ): Observable<Discipline[]> {
    return this.http.get<Discipline[]>(
      `${this.apiRoot}/getAllDiscApproversByUniqueKey/${uniqueKey}`
    );
  }

  // Deprecated
  // public createUserDisciplineBusinessUnit(userId: number, disciplineId: number, businessUnitId: number): Observable<UserDisciplineBusinessUnit>{
  //   const endPoint = `${this.apiRoot}/createUserDisciplineBusinessUnit`
  //   const body = {userId, disciplineId, businessUnitId};
  //   return this.http.post<UserDisciplineBusinessUnit>(endPoint, body);
  // }

  public getAllDiscApproversByDisciplineIdAndBusinessUnitId(
    disciplineId: number,
    businessUnitId: number
  ): Observable<User[]> {
    return this.http.get<User[]>(
      `${this.apiRoot}/getAllDiscApproversByDisciplineIdAndBusinessUnitId/${disciplineId}/${businessUnitId}`
    );
  }

  public createUserDisciplineBusinessUnit(
    triggerCode: string,
    uniqueKey: string,
    businessUnitCode: string
  ): Observable<HttpResponse<UserDisciplineBusinessUnit>> {
    const endPoint = `${this.apiRoot}/createUserDisciplineBusinessUnitV2`;
    const body = { triggerCode, uniqueKey, businessUnitCode };
    return this.http.post<UserDisciplineBusinessUnit>(endPoint, body, {
      observe: "response",
    });
  }

  public deleteUserDisciplineBusinessUnit(
    uniqueKey: string,
    discipline: string,
    businessUnit: string
  ) {
    const endPoint = `${this.apiRoot}/deleteUserDisciplineBusinessUnit/uniqueKey=${uniqueKey}/discipline=${discipline}/businessUnit=${businessUnit}`;
    return this.http.delete(endPoint);
  }
}
